import React from "react";
import { Link } from "react-router-dom";
import HasPermission from "../../../../core/common/wrapper/HasPermission";
import {
  MODULES,
  MODULES_ACTIONS,
} from "../../../../core/data/constants/moduleConstants";
import CompanyFilter from "../../../../core/common/crmComponents/CompanyFilter";
import CommonFilter from "../../../../core/common/crmComponents/filters/CommonFilter";
import ClearAllFilters from "../../../../core/common/crmComponents/filters/ClearAllFilters";
import ReloadButton from "../../../../core/common/crmComponents/ReloadButton";

const CardHeader = ({ selectedCompany, setSelectedCompany, user }) => {
  return (
    <div className="card-header py-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* Filters */}
        <div className="d-flex flex-wrap gap-3">
          <ReloadButton moduleName={MODULES.USERS} />

          <CompanyFilter
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            user={user}
          />
        </div>

        <div className="gap-3 d-flex align-items-center ">
          <div className="d-flex gap-1">
            <CommonFilter module={MODULES.USERS} />
            <ClearAllFilters module={MODULES.USERS} />
          </div>

          {/* Add User Button */}
          <HasPermission module={MODULES.USERS} action={MODULES_ACTIONS.CREATE}>
            <Link
              to="#"
              className="btn btn-primary custom-btn-padding"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_add"
            >
              <i className="ti ti-square-rounded-plus me-2" />
              Add user
            </Link>
          </HasPermission>
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
